import { FC } from 'react'

import { useLegalBannerContext } from '@/contexts/LegalBannerContext'
import { Button } from '@getethos/ethos-design-system-v2'
import classNames from 'classnames'

import { useRebrandingTreatment } from '@/hooks/features/useRebrandingRefresh'
import useDetectScreenSize from '@/hooks/useDetectScreenSize'

import { LegalBannerProps } from '../interfaces'
import styles from './TransparentBanner.module.scss'

export const TransparentBanner: FC<LegalBannerProps> = ({
  content,
  onAccept,
  onDismiss,
}) => {
  const { isLaptopAndUp } = useDetectScreenSize()
  const { setDisclaimerHeight } = useLegalBannerContext()

  const { isEnabled: useNewFonts } = useRebrandingTreatment()

  return (
    <div
      className={styles.container}
      role="dialog"
      aria-label="Cookie consent banner"
      ref={(ref) => {
        if (ref) {
          setDisclaimerHeight?.(ref.clientHeight)
        }
      }}
    >
      <div className={classNames(styles.innerContainer)}>
        <div className={styles.contentContainer}>
          <div
            className={classNames(styles.text, {
              [styles.newFonts]: useNewFonts,
            })}
          >
            {content}
          </div>
        </div>
        <div
          className={classNames(styles.buttons, {
            [styles.newFonts]: useNewFonts,
          })}
        >
          <Button
            buttonTitle="Accept"
            variant="primary"
            onClick={onAccept}
            size={isLaptopAndUp ? 'md' : 'sm'}
          />
          <Button
            buttonTitle="Decline"
            variant="link"
            className={styles.declineButton}
            onClick={onDismiss}
            size={isLaptopAndUp ? 'md' : 'sm'}
          />
        </div>
      </div>
    </div>
  )
}
